__turbopack_context__.v({
  "closeBtn": "LangSelectorModal-module__efCcwq__closeBtn",
  "contentWrapper": "LangSelectorModal-module__efCcwq__contentWrapper",
  "langList": "LangSelectorModal-module__efCcwq__langList",
  "langListWrapper": "LangSelectorModal-module__efCcwq__langListWrapper",
  "modalWrapper": "LangSelectorModal-module__efCcwq__modalWrapper",
});
